<template>
  <b-card no-body>
<b-card-body class="p-1">
  <b-row class="mb-2">
    <b-col md="6" xl="3">
      <label>Desde</label>
      <b-input-group class="mb-1">
        <b-form-datepicker
          id="txtFechaInicio"
          v-model="txtFechaInicio"
          locale="es-ES"
        ></b-form-datepicker>
      </b-input-group>
    </b-col>

    <b-col md="6" xl="3">
      <label>Hasta</label>
      <b-input-group class="mb-1">
        <b-form-datepicker
          id="txtFechaFin"
          v-model="txtFechaFin"
          locale="es-ES"
        ></b-form-datepicker>
      </b-input-group>
    </b-col>

    <!-- Botones alineados con los filtros -->
    <b-col md="12" xl="6" class="d-flex align-items-end">
      <b-button
        variant="gradient-primary"
        size="sm"
        class="mr-1"
        :disabled="loading"
        @click="traerRegistros"
      >
        <feather-icon icon="FilterIcon" class="mr-50" />
        <span class="align-middle">Filtrar</span>
      </b-button>

      <b-button
        v-if="$can('create', 'trabajaenagrovision')"
        variant="gradient-primary"
        size="sm"
        class="ml-1"
        :disabled="loading2"
        @click="descargarFile"
        style="min-width: 150px; white-space: nowrap;"
      >
        <span v-if="loading2">
          Generando Archivo..&emsp;<b-spinner style="width: 16px; height: 16px;" />
        </span>
        <span v-else class="d-flex align-items-center">
          <feather-icon icon="ExternalLinkIcon" class="mr-1" />
          <span>Exportar Excel</span>
        </span>
      </b-button>
    </b-col>
  </b-row>
</b-card-body>
    <b-table
      hover
      responsive
      small
      class="position-relative"
      :per-page="perPage"
      :current-page="currentPage"
      :items="items"
      :fields="fields"
      :busy="loading"
    >
      <template #table-busy>
        <div class="text-center text-dark my-1">
          <b-spinner class="align-middle"></b-spinner> &emsp;
          <strong>Obteniendo datos...</strong>
        </div>
      </template>
      <template #cell(volveria_trabajar)="data">
        <span>
          {{ data.value === true ? "Sí" : data.value === false ? "No" : "" }}
        </span>
      </template>
      <template #cell(created)="data">
        <span class="text-nowrap">
          {{
            new Date(data.value).toLocaleString("es-PE", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              timeZone: "America/Lima",
            })
          }}
        </span>
      </template>
    </b-table>
    <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
      <b-form-group
        label="Mostrar"
        label-cols="5"
        label-align="left"
        label-size="sm"
        label-for="perPageSelect"
        class="text-nowrap mb-md-0 mr-1"
      >
        <b-form-select
          id="perPageSelect"
          v-model="perPage"
          size="sm"
          inline
          :options="pageOptions"
        />
      </b-form-group>
      <div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </b-card-body>
  </b-card>
</template>
  
  <script>
import axiosIns from "../../libs/axios";
import moment from "moment";
import {
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BButton,
  BCardBody,
  BRow,
  BCol,
  BSpinner,
  BFormDatepicker,
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BCardBody,
    BSpinner,
    BRow,
    BCol,
    BFormDatepicker,
  },
  data() {
    return {
      perPage: 15,
      pageOptions: [15, 25, 50],
      totalRows: 1,
      currentPage: 1,
      loading: false,
      items: [],
      fields: [
        { key: "dni_responsable", label: "DNI Responsable", sortable: true },
        { key: "departamento", label: "Departamento", sortable: true },
        { key: "distrito", label: "Distrito", sortable: true },
        { key: "centro_poblado", label: "Centro Poblado", sortable: true },
        { key: "paradero", label: "Paradero", sortable: true },
        { key: "direccion", label: "Dirección", sortable: false },
        { key: "celular", label: "Celular", sortable: false },
        { key: "whatsapp", label: "Whatsapp", sortable: false },
        { key: "motivo_falta", label: "Motivo Falta", sortable: false },
        {
          key: "motivo_falta_otros",
          label: "Otro Motivo de Falta",
          sortable: false,
        },
        {
          key: "volveria_trabajar",
          label: "¿Volvería a Trabajar?",
          sortable: false,
        },
        { key: "motivo_no_volver", label: "Motivo No Volver", sortable: false },
        { key: "semana_ingreso", label: "Semana Ingreso", sortable: false },
        {
          key: "cambio_domicilio",
          label: "¿Cambio Domicilio?",
          sortable: false,
        },
        { key: "aspecto_dificil", label: "Aspecto Difícil", sortable: false },
        { key: "apoyo_empresa", label: "Apoyo Empresa", sortable: false },
      ],

      //PARAMS FILTER
      txtFechaInicio: moment().format("YYYY-MM-DD"),
      txtFechaFin: moment().format("YYYY-MM-DD"),
    };
  },
  mounted() {
    this.traerRegistros();
  },
  methods: {
    traerRegistros() {
      this.loading = true;
      axiosIns
        .get(
          `/trabajaenagrovision/registrosreclutamiento?fecha_inicio=${this.txtFechaInicio}&fecha_fin=${this.txtFechaFin}`
        )

        .then((response) => {
          // Los campos ya vienen como texto directo, no necesitan mapeo
          this.items = response.data;
          this.totalRows = this.items.length;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    descargarFile() {
      var yo = this;
      this.loading2 = true;
      var config = {
        method: "GET",
        url: `/trabajaenagrovision/registrosreclutamiento/exportar?fecha_inicio=${this.txtFechaInicio}&fecha_fin=${this.txtFechaFin}`,
        headers: {
          "Content-Type": "application/json",
        },
        responseType: "arraybuffer",
      };

      axiosIns(config)
        .then(function (response) {
          if (response.status === 200) {
            console.log("Enviado");
            console.log(response);
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "RegistrosAusentismo.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();

            yo.$toast(
              {
                component: ToastificationContent,
                props: {
                  title: "Archivo creado",
                  icon: "CheckIcon",
                  text: "El archivo se creó satisfactoriamente.",
                  variant: "success",
                },
              },
              {
                position: "top-center",
              }
            );
          } else if (response.status === 204) {
            yo.$toast({
              component: ToastificationContent,
              props: {
                title: "No existen registros",
                icon: "AlertTriangleIcon",
                text: "No se encontraron registros con los parámetros solicitados.",
                variant: "warning",
              },
            });
          }
        })
        .catch(function (error) {
          console.log(error);
          yo.$toast({
            component: ToastificationContent,
            props: {
              title: "Error en la creación del archivo",
              icon: "XIcon",
              text: "Hubo un error en la creación del archivo, intentelo nuevamente en unos minutos.",
              variant: "danger",
            },
          });
        })
        .finally(function () {
          yo.loading2 = false;
        });
    },
  },
};
</script>
  